"use client";
import { NewsletterModal } from "./NewsletterModal";
import { useState } from "react";
import { usePathname } from "next/navigation";

export default function NewsletterModalClient() {
    const pathname = usePathname();
    const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    // Suppress on private share pages — they should feel transactional, not marketing.
    if (pathname?.startsWith('/share/') || pathname === '/share') {
        return null;
    }

    return (
        <NewsletterModal isOpen={isOpen} openModal={openModal} closeModal={closeModal} />
    );
};
